import { MouseManager } from '@awayjs/scene';
var hasshownServerError = false;
function serverError(error) {
    if (hasshownServerError)
        return;
    hasshownServerError = true;
    alert('Can not connect to Server. Is Server.js running ?');
}
export var TEST_MODE;
(function (TEST_MODE) {
    TEST_MODE["TESTING"] = "TESTING";
    TEST_MODE["RECORDING"] = "RECORDING";
})(TEST_MODE || (TEST_MODE = {}));
var AVMTestHandler = /** @class */ (function () {
    function AVMTestHandler(config, avmStage) {
        var _this = this;
        this.frameIdx = 0;
        this.snapshotCnt = 0;
        this.snapShotsUploaded = 0;
        this.config = config;
        this._avmStage = avmStage;
        this.frameIdx = 0;
        this.events = {};
        this.reportedSWFInfos = false;
        this.frames = [{
                messages: [],
                frameIdx: this.frameIdx
            }];
        this._finished = false;
        this.snapshotCnt = 0;
        if (this.config.recordtest)
            MouseManager.inputRecorder = this;
        //if(this.config.mode==TEST_MODE.RECORDING){
        //	if recording, we must have a way to stop the recording,
        //	so we listen for a keyboard sortcut here on window
        window.addEventListener('keydown', function (event) {
            if (event.ctrlKey && event.keyCode == 69) {
                _this.finishTest();
            }
        });
        //}
    }
    /**
     * called from trace-function, to collect all traces for a frame
     * @param message
     */
    AVMTestHandler.prototype.addMessage = function (message) {
        if (this._finished)
            return;
        this.frames[this.frames.length - 1].messages.push(message);
        this.checkIfFinished();
    };
    AVMTestHandler.prototype.setSWF = function (swfFile) {
        this.swfInfo = {
            frameRate: swfFile.frameRate,
            swfVersion: swfFile.swfVersion,
            asVersion: swfFile.useAVM1 ? 2 : 3,
            width: swfFile.bounds.width / 20,
            height: swfFile.bounds.height / 20,
        };
    };
    AVMTestHandler.prototype.recordEvent = function (event) {
        if (this.config.settings.snapShotOnMouseDown && event.type == 'mousedown')
            this.takeSnapshot();
        if (this.config.settings.snapShotOnMouseUP && event.type == 'mouseup')
            this.takeSnapshot();
        if (!this.config.recordtest)
            return;
        // todo allow to filter out all mousemove commands
        if (!this.config.settings.recordInput)
            return;
        //if(event.type==)
        if (!this.events[this.frameIdx])
            this.events[this.frameIdx] = [];
        var jsonEvent = {
            type: event.type,
            screenX: event.screenX,
            screenY: event.screenY,
            clientX: event.clientX,
            clientY: event.clientY,
            ctrlKey: event.ctrlKey,
            altKey: event.altKey,
            shiftKey: event.shiftKey
        };
        this.events[this.frameIdx].push(jsonEvent);
    };
    AVMTestHandler.prototype.dispatchEvents = function () {
        if (this.config.recordtest)
            return;
        if (this.config.events && this.config.events[this.frameIdx]) {
            for (var i = 0; i < this.config.events[this.frameIdx].length; i++) {
                var jsonEvent = this.config.events[this.frameIdx][i];
                jsonEvent.preventDefault = function () { };
                switch (jsonEvent.type) {
                    case 'click':
                        MouseManager.getInstance(null).onClick(jsonEvent);
                        break;
                    case 'dblclick':
                        MouseManager.getInstance(null).onDoubleClick(jsonEvent);
                        break;
                    case 'touchstart':
                        MouseManager.getInstance(null).onMouseDown(jsonEvent);
                        break;
                    case 'mousedown':
                        if (this.config.settings.snapShotOnMouseDown)
                            this.takeSnapshot();
                        MouseManager.getInstance(null).onMouseDown(jsonEvent);
                        break;
                    case 'touchmove':
                        MouseManager.getInstance(null).onMouseMove(jsonEvent);
                        break;
                    case 'mousemove':
                        MouseManager.getInstance(null).onMouseMove(jsonEvent);
                        break;
                    case 'mouseup':
                        if (this.config.settings.snapShotOnMouseUP)
                            this.takeSnapshot();
                        MouseManager.getInstance(null).onMouseUp(jsonEvent);
                        break;
                    case 'touchend':
                        MouseManager.getInstance(null).onMouseUp(jsonEvent);
                        break;
                    case 'touchend':
                        MouseManager.getInstance(null).onClick(jsonEvent);
                        break;
                    case 'mousewheel':
                        MouseManager.getInstance(null).onMouseWheel(jsonEvent);
                        break;
                    case 'mouseover':
                        MouseManager.getInstance(null).onMouseOver(jsonEvent);
                        break;
                    case 'mouseout':
                        MouseManager.getInstance(null).onMouseOut(jsonEvent);
                        break;
                    case 'keydown':
                        MouseManager.getInstance(null).onKeyDown(jsonEvent);
                        break;
                    case 'keyup':
                        MouseManager.getInstance(null).onKeyUp(jsonEvent);
                        break;
                }
            }
        }
    };
    AVMTestHandler.prototype.closeBrowserTab = function () {
        if (!this._finished)
            return;
        if ((this.snapShotsUploaded == 0 && this.snapshotCnt == 0) || this.snapShotsUploaded == this.snapshotCnt) {
            this.finishAndUploadTest();
        }
    };
    AVMTestHandler.prototype.takeSnapshot = function () {
        if (this._finished)
            return;
        var myThis = this;
        var snapShotFrame = this.snapshotCnt++;
        this.addMessage('AWAYFLTEST SNAPSHOT ' + snapShotFrame);
        this._avmStage.snapshot(function (htmlCanvas) {
            htmlCanvas.toBlob(function (blob) { return onBlob(blob); });
            function onBlob(blob) {
                console.log('snapshot done');
                var formData = new FormData();
                var fileName = 'snapshot_' + snapShotFrame + '.png';
                formData.append('file', blob, fileName);
                var request = new XMLHttpRequest();
                request.onreadystatechange = function (oEvent) {
                    if (request.readyState == 4) {
                        if (request.status == 200 || request.status == 0) {
                            //console.log("AWAYFLTEST END");
                            myThis.snapShotsUploaded++;
                            myThis.closeBrowserTab();
                            //console.log(request.responseText)
                        }
                        else {
                            serverError(request.statusText + '-' + request.readyState + '-' + request.responseText + '-' + request.status);
                        }
                    }
                };
                request.onerror = function (e) {
                    serverError(request.statusText + '-' + request.readyState + '-' + request.responseText + '-' + request.status);
                };
                try {
                    request.open('POST', 'http://localhost:' + myThis.config.port + '/uploadImage', true);
                    request.send(formData);
                }
                catch (e) {
                    serverError('Could not save json on server. The Server.js is probably not running. Error: ' + e);
                }
            }
        });
    };
    /**
     * called from onEnter on stage
     */
    AVMTestHandler.prototype.nextFrame = function () {
        this.frameIdx++;
        if (this.config.settings.stopRecAfterFrame > 0 && this.frameIdx > this.config.settings.stopRecAfterFrame) {
            this.finishTest();
        }
        if (this._finished)
            return;
        if (this.config.settings.snapShotFrames != 0 && this.frameIdx % this.config.settings.snapShotFrames == 0)
            this.takeSnapshot();
        if (!this.config.settings.onlyTraces) {
            if (this.frames[this.frames.length - 1].messages.length > 0) {
                this.frames.push({
                    messages: [],
                    frameIdx: this.frameIdx,
                });
            }
            else {
                this.frames[this.frames.length - 1].frameIdx = this.frameIdx;
            }
        }
    };
    AVMTestHandler.prototype.checkIfFinished = function () {
        if (this.config.frames) {
            if (this.config.frames.length < this.frames.length) {
                // more test frames than recordet frames. test is complete (and propably failed)
                this.finishTest();
                return;
            }
            var currentRecordetFrame = -1;
            for (var i = 0; i < this.config.frames.length; i++) {
                if (this.config.frames[i].frameIdx == this.frames[this.frames.length - 1].frameIdx) {
                    currentRecordetFrame = i;
                }
            }
            if (currentRecordetFrame == -1) {
                // no recordet frame found for this frameIdx. test is complete (and propably failed)
                this.finishTest();
                return;
            }
            if (currentRecordetFrame == this.config.frames.length - 1) {
                // last of the recordet frames, if test frame has same number of messages, test is complete
                var len1 = this.config.frames[currentRecordetFrame].messages.length;
                var len2 = this.frames[this.frames.length - 1].messages.length;
                if (len2 >= len1) {
                    this.finishTest();
                }
            }
        }
    };
    AVMTestHandler.prototype.finishTest = function () {
        if (this._finished)
            return;
        this._finished = true;
        this.closeBrowserTab();
    };
    AVMTestHandler.prototype.finishAndUploadTest = function () {
        if (this.frames[this.frames.length - 1].messages.length == 0) {
            this.frames.pop();
        }
        var myThis = this;
        var path = window.location.pathname;
        var page = path.split('/').pop().replace('.html', '');
        var data = {
            player: 'awayflplayer',
            duration: Date.now() - this.config.startRecTime,
            date: new Date().toLocaleString(),
            url: page,
            swf: this.config.swfPath,
            swfInfos: this.swfInfo,
            settings: this.config.settings,
            frames: this.frames,
            events: this.events,
            seed: this.config.seed,
        };
        var json = JSON.stringify(data);
        var formData = new FormData();
        var blob = new Blob([json], { type: 'text/xml' });
        if (this.config.recordtest) {
            var fileName = this.config.swfPath.replace(/\\/g, '/');
            formData.append('file', blob, fileName);
            formData.append('record', 'true');
        }
        else {
            var fileName = this.config.swfPath.replace(/\\/g, '/') + '/' + this.config.testPath;
            formData.append('file', blob, fileName);
        }
        var request = new XMLHttpRequest();
        request.onreadystatechange = function (oEvent) {
            if (request.readyState == 4) {
                if (request.status == 200 || request.status == 0) {
                    console.log('AWAYFLTEST END');
                    //window.close();
                    //console.log(request.responseText)
                }
                else {
                    serverError(request.statusText + '-' + request.readyState + '-' + request.responseText + '-' + request.status);
                }
            }
        };
        request.onerror = function (e) {
            serverError(request.statusText + '-' + request.readyState + '-' + request.responseText + '-' + request.status);
        };
        try {
            request.open('POST', 'http://localhost:' + this.config.port + '/upload', true);
            request.send(formData);
        }
        catch (e) {
            serverError('Could not save json on server. The Server.js is probably not running. Error: ' + e);
        }
    };
    return AVMTestHandler;
}());
export { AVMTestHandler };
